
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteN as ObiOwnShipRemoteNElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-n.js';
 
 
 

 
 export const ObiOwnShipRemoteN = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-n',
   elementClass: ObiOwnShipRemoteNElement,
   events: {
     
   }
  });
 
 